import React from "react";
import SensorsRoundedIcon from "@mui/icons-material/SensorsRounded";
import useCardReader from "./useCardReader";
import "../cardReader/cardReader.scss";

const CardReader = ({ id, onCardRead }) => {
    const { readCard } = useCardReader();

    const handleRead = async () => {
        const cardNumber = await readCard();

        if (cardNumber) {
            onCardRead(cardNumber);
        }
    };

    if (id) return

    return (
        <button
            type="button"
            className="cardReader"
            onClick={handleRead}
        >
            <SensorsRoundedIcon />
        </button>
    );
};

export default CardReader;